/* eslint-disable func-names */
/* eslint-disable no-underscore-dangle */
import authorizationService from '../../common/services/security/authorizationService';
import userTokenService from '../../common/services/security/userTokenService';

const install = () => {
  const apiKey = process.env.REACT_APP_USER_ANALYTICS_API_KEY;

  if (
    !window.pendo &&
    apiKey &&
    userTokenService.isActiveAnalyticsTerritory()
  ) {
    // Step 1: initialize pendo object
    const pendoObjectReference = window.pendo || {};
    window.pendo = pendoObjectReference;
    pendoObjectReference._q = [];

    // Step 2: add method stubs for pendo
    ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'].forEach(
      (method, _index, methods) => {
        pendoObjectReference[method] =
          pendoObjectReference[method] ||
          function (...args) {
            const callToAdd = [method, ...args];
            if (method === methods[0]) {
              pendoObjectReference._q.unshift(callToAdd);
            } else {
              pendoObjectReference._q.push(callToAdd);
            }
          };
      }
    );

    // Step 3: create pendo script tag
    const elementToCreateSelector = 'script';
    const createdPendoScriptTag = document.createElement(
      elementToCreateSelector
    );
    createdPendoScriptTag.src = `https://cdn.pendo.io/agent/static/${apiKey}/pendo.js`;

    // Step 4: add pendo script to DOM
    const firstScriptTag = document.getElementsByTagName(
      elementToCreateSelector
    )[0];
    firstScriptTag.parentNode.insertBefore(
      createdPendoScriptTag,
      firstScriptTag
    );
  }
};

const supplementPwcusertype = () => {
  const isInternal = authorizationService.getTokenValue('isInternal');

  if (isInternal !== null && isInternal === 'True') {
    return 'Internal';
  }
  return 'External';
};

const start = () => {
  const { pendo } = window;
  if (!pendo) return;
  if (!authorizationService.hasValidToken()) return;

  const lineofservice =
    authorizationService.getTokenValue(
      'http://schemas.pwc.com/identity/claims/lineofservice'
    ) || '';
  const country =
    authorizationService.getTokenValue(
      'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/country'
    ) || 'US';
  const pwcGlobalGradeName =
    authorizationService.getTokenValue(
      'http://schemas.pwc.com/identity/claims/pwcglobalgradename' // Not available in IDAM yet (user access API adds it we have it)
    ) || '';
  const pwcUserType =
    authorizationService.getTokenValue(
      'http://schemas.pwc.com/identity/claims/pwcusertype'
    ) || supplementPwcusertype();

  pendo.initialize({
    visitor: {
      lineofservice,
      country,
      pwcGlobalGradeName,
      pwcUserType,
    },
  });

  pendo.started = true;
};

const isInstalled = () => {
  const { pendo } = window;
  return !!pendo;
};

const isStarted = () => {
  const { pendo } = window;

  return pendo.started;
};

const pendoService = {
  install,
  start,
  isInstalled,
  isStarted,
};

export default pendoService;
